import moment from "moment";
moment.locale();

export const formatDate = (date: string) => moment(date).format("L");
